import ManageUserPage from './ManageUserPage';

export default ManageUserPage;
export { default as reducerUser } from './user.ducks';
export { default as reducerCredit } from './credit.ducks';
export { default as reducerAdminNotes } from './adminNotes.ducks';



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageUserPage/index.ts